import { render, staticRenderFns } from "./external-player.vue?vue&type=template&id=029aa1f0&scoped=true"
import script from "./external-player.vue?vue&type=script&setup=true&lang=js"
export * from "./external-player.vue?vue&type=script&setup=true&lang=js"
import style0 from "./external-player.vue?vue&type=style&index=0&id=029aa1f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029aa1f0",
  null
  
)

export default component.exports